import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'gabarito-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  subscriptionStep = 1;
  questionStep = 1;
  questionStepResult = 1;


  constructor(private router: Router) { }

  ngOnInit() {
    if (this.router.url === '/applicant') {
      this.router.navigate(['/applicant/dashboard']);
    } else if (this.router.url === '/employee') {
      this.router.navigate(['/employee/correct']);
    }
  }

}
